import React, { useState } from 'react';
import {
  Switch,
  styled,
} from '@mui/material';

// Custom styled switch with green color on active
const Switches = styled(Switch)(({ theme }) => ({
  '& .MuiSwitch-switchBase.Mui-checked': {
    color: 'green',
    '& + .MuiSwitch-track': {
      backgroundColor: 'green',
    },
  },
  '& .MuiSwitch-switchBase': {
    color: '#1b75ba',
  },
  '& .MuiSwitch-track': {
    backgroundColor: '#ccc',
  },
}));

const CustomSwitch = () => {
  const [isActive, setIsActive] = useState(true);

  const switchToggle = (event: React.ChangeEvent<HTMLInputElement>) => {
    setIsActive(event.target.checked);
  };

  return (
    <>
      <Switches checked={isActive} onChange={switchToggle} />
    </>
  );
};

export default CustomSwitch;
